export const moveToFolderCreateNewAriaLabel = "PDc";
export const moveToFolderCreateNewTooltip = "QDc";
export const moveToFolderAddFolderNameText = "RDc";
export default {moveToFolderCreateNewAriaLabel,moveToFolderCreateNewTooltip,moveToFolderAddFolderNameText};